/* PERDAH KEMER — davranış katmanı (perdah-lux.html ailesi birebir) */
(function () {
  'use strict';

  /* mobil menü */
  var mnav = document.getElementById('pk-mnav');
  if (mnav) {
    mnav.addEventListener('click', function () {
      var open = document.body.classList.toggle('pk-mopen');
      mnav.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* koleksiyon: sıralama — Shopify native sort_by (form içindeyse filtre formu yönetir) */
  var sort = document.getElementById('pk-sort');
  if (sort && !sort.form) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', this.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  /* ürün: galeri */
  var galMain = document.getElementById('pk-gal-main');
  if (galMain) {
    document.querySelectorAll('.pk-th').forEach(function (th) {
      th.addEventListener('click', function () {
        document.querySelectorAll('.pk-th').forEach(function (t) {
          t.classList.remove('on');
          t.setAttribute('aria-pressed', 'false');
        });
        th.classList.add('on');
        th.setAttribute('aria-pressed', 'true');
        galMain.style.opacity = '0';
        var im = new Image();
        im.onload = function () {
          galMain.src = th.dataset.src;
          if (th.dataset.srcset) galMain.srcset = th.dataset.srcset; else galMain.removeAttribute('srcset');
          galMain.alt = th.dataset.alt || '';
          galMain.style.opacity = '1';
        };
        im.src = th.dataset.src;
      });
    });
  }

  /* ürün: beden seçimi etiketi */
  var szSel = document.getElementById('pk-szsel');
  if (szSel) {
    document.querySelectorAll('.pk-sz input').forEach(function (r) {
      r.addEventListener('change', function () {
        szSel.textContent = (r.dataset.label || r.value);
      });
    });
  }

  /* ürün: yapışkan satın al çubuğu */
  var sbar = document.getElementById('pk-sbar');
  var buyBtn = document.querySelector('.pk-buy');
  if ('IntersectionObserver' in window && sbar && buyBtn) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sbar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(buyBtn);
  }

  /* tek animasyon: yumuşak beliriş (gizli durum JS ile verilir; JS yoksa içerik görünür) */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);
  gsap.utils.toArray('[data-r]').forEach(function (el) {
    gsap.from(el, {
      opacity: 0, y: 12, duration: 0.35, ease: 'power1.out',
      scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none reverse' }
    });
  });
})();


/* Perdah — yapiskan cubukta beden seçimi.
   Yapışkan cubuk zaten JS ile açılıyor; seçici de burada kuruluyor.
   Sepete ekleme yine ana formdaki radio üzerinden gider. */
(function () {
  var bar = document.getElementById("pk-sbar");
  var form = document.getElementById("pk-product-form");
  if (!bar || !form) return;
  var icerik = bar.querySelector(".pk-sbarin");
  var radios = [].slice.call(form.querySelectorAll('input[name="id"]'));
  if (!icerik || radios.length < 2) return;

  var css = document.createElement("style");
  css.textContent =
    ".pk-sbact{display:flex;align-items:center;gap:14px;margin-left:auto}" +
    ".pk-sbsz{display:flex;align-items:center;gap:9px}" +
    ".pk-sbsz-et{font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:var(--pk-sec,#5C4C3A);white-space:nowrap}" +
    ".pk-sbsz select{height:44px;min-width:106px;padding:0 32px 0 12px;border:1px solid var(--pk-line,#E0D6C4);" +
    "background-color:var(--pk-plate,#FBF8F2);color:var(--pk-ink,#1C1712);font-family:inherit;font-size:12.5px;" +
    "border-radius:0;cursor:pointer;-webkit-appearance:none;appearance:none;" +
    "background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Cpath fill='%235C4C3A' d='M210.83,90.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,162.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z'/%3E%3C/svg%3E\");" +
    "background-repeat:no-repeat;background-position:right 11px center;background-size:11px}" +
    ".pk-sbsz select:hover{border-color:var(--pk-ink,#1C1712)}" +
    ".pk-sbsz select:focus-visible{outline:2px solid var(--pk-gold,#A6803F);outline-offset:2px}" +
    "@media(max-width:780px){.pk-sbsz-et{display:none}.pk-sbsz select{min-width:92px}.pk-sbact{gap:10px}}" +
    "@media(max-width:480px){.pk-sbsz select{min-width:84px;padding:0 28px 0 10px}}";
  document.head.appendChild(css);

  var sarmal = document.createElement("div");
  sarmal.className = "pk-sbact";
  var etiketKutu = document.createElement("label");
  etiketKutu.className = "pk-sbsz";
  var et = document.createElement("span");
  et.className = "pk-sbsz-et";
  et.textContent = "Beden";
  var sec = document.createElement("select");
  sec.id = "pk-sbar-varyant";
  sec.setAttribute("aria-label", "Beden seçimi");

  radios.forEach(function (r) {
    var o = document.createElement("option");
    o.value = r.value;
    o.textContent = r.getAttribute("data-label") || r.value;
    if (r.disabled) { o.disabled = true; o.textContent += " · tükendi"; }
    if (r.checked) o.selected = true;
    sec.appendChild(o);
  });

  etiketKutu.appendChild(et);
  etiketKutu.appendChild(sec);
  sarmal.appendChild(etiketKutu);

  var btn = icerik.querySelector(".pk-sbbuy");
  if (btn) { sarmal.appendChild(btn); }
  icerik.appendChild(sarmal);

  var yaziEtiket = document.getElementById("pk-szsel");
  sec.addEventListener("change", function () {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === sec.value && !radios[i].disabled) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event("change", { bubbles: true }));
        if (yaziEtiket) yaziEtiket.textContent = radios[i].getAttribute("data-label") || radios[i].value;
        break;
      }
    }
  });
  radios.forEach(function (r) {
    r.addEventListener("change", function () { if (r.checked) sec.value = r.value; });
  });
})();
